import { getOssUrl } from '../utils';

export default function useUrl() {
  const ossProvider = 'oss-cn-shenzhen',
    host = 'aliyuncs.com';
  // url=/public-dev-shop/mall/0d7b1cd4-5e4f-4e88-a910-0af2a89385c6.png

  return {
    getPublicUrl(url) {
      // eslint-disable-next-line prefer-destructuring
      const bucketName = url.split('/')[1];
      const suffix = url.split('/').slice(2).join('/');
      const conf: any = {
        ossProvider,
        bucketName,
        host,
      };
      return getOssUrl(suffix, conf);
    },
  };
}
